export default __webpack_public_path__ + "static/media/Legend12.44725533.jpeg";